export default __webpack_public_path__ + "static/media/dblogo.f2c6023b.svg";